import { TradeCommand } from "../../services/holdings";
import { ChargeNoun, InvestmentTrackingMode } from "./types";

export const TRACKING_MODE_LABELS: Record<InvestmentTrackingMode, string> = {
  MANUAL_MARKET_UPDATES: "Manual market updates",
  HOLDINGS_LEDGER: "Broker ledger",
};

export const TRACKING_MODE_DESCRIPTIONS: Record<
  InvestmentTrackingMode,
  string
> = {
  MANUAL_MARKET_UPDATES:
    "Record portfolio values and transfers yourself with manual market updates.",
  HOLDINGS_LEDGER:
    "Track buys, holdings and market prices in a holdings ledger built from dated records.",
};

export const TRACKING_MODE_IMMUTABLE_NOTE =
  "Choose a tracking method when you create the investment. It can't be changed later.";

export const ACTIVITY_PAGE_SIZE = 5;

export const CASH_TRANSFER_DELETE_TITLE = "Delete transfer";

// Shared so the desktop table and mobile card don't word the same missing-counterparty state differently.
export const TRANSFER_COUNTERPARTY_FALLBACK = "the external account";

export const BROKERAGE_ACCOUNT_FALLBACK = "this brokerage account";

export const LINKED_ACCOUNT_FALLBACK = "the linked account";

// Below this, money's two decimals can't say anything true — a crypto unit worth a
// fraction of a cent would otherwise print as `0,00 €`.
export const SUB_UNIT_PRICE_THRESHOLD = 1;

// The server's own quote precision (`DECIMAL(20,8)`) — widening past it renders digits never stored.
export const MAX_QUOTE_FRACTION_DIGITS = 8;

// Account-level commands (deposit, withdrawal, fee, interest) have `instrument: null`; a name here
// rather than a dash, since the row is still a real movement of the account's money.
export const ACCOUNT_LEVEL_POSITION = "Account cash";

// The single place a command's charge is derived from its `chargeKind`, so the correction panel and
// the activity feed can't disagree. `MIXED` resolves to fee since the server clamps it non-editable anyway.
export const CHARGE_KIND_TO_NOUN: Record<
  NonNullable<TradeCommand["chargeKind"]>,
  ChargeNoun
> = {
  FEE: "fee",
  WITHHOLDING_TAX: "withholdingTax",
  MIXED: "fee",
};
